import { PropsWithChildren, useEffect, useRef } from 'react';
import { renderMermaidCandidates } from '../modules/mermaid/mermaidRenderer';

// rehypeMermaidBlocks (see qetaRehypePlugins.ts) turns ```mermaid fences into `.mermaid`
// marker divs; this observes the DOM for those divs and replaces them with rendered SVG.
export const QetaMermaidObserver = ({ children }: PropsWithChildren<{}>) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return undefined;

    const scan = () => {
      renderMermaidCandidates(
        Array.from(container.querySelectorAll('.mermaid')),
        false,
      );
    };

    scan();
    const observer = new MutationObserver(scan);
    observer.observe(container, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return <div ref={containerRef}>{children}</div>;
};
